export default __webpack_public_path__ + "static/media/VC_icon.89ebc467.png";